"use strict";
exports.__esModule = true;
exports.OrganisationMemberDocument = void 0;
var OrganisationMemberDocument = /** @class */ (function () {
    function OrganisationMemberDocument(org_id, uid, account_settings, //access to account settings or not
    access_id, last_login_at, created_at, updated_at, is_deleted, is_active) {
        this.org_id = org_id;
        this.uid = uid;
        this.account_settings = account_settings;
        this.access_id = access_id;
        this.last_login_at = last_login_at;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.is_deleted = is_deleted;
        this.is_active = is_active;
    }
    OrganisationMemberDocument.fromJSON = function (json) {
        var organisationMember = new OrganisationMemberDocument('', '', false, '', 0, 0, 0, false, true);
        if (json) {
            organisationMember.org_id = json.org_id ? json.org_id : '';
            organisationMember.uid = json.uid ? json.uid : '';
            organisationMember.account_settings = json.account_settings !== undefined ? json.account_settings : false;
            organisationMember.access_id = json.access_id ? json.access_id : '';
            organisationMember.last_login_at = json.last_login_at ? json.last_login_at : 0;
            organisationMember.created_at = json.created_at ? json.created_at : 0;
            organisationMember.updated_at = json.updated_at ? json.updated_at : 0;
            organisationMember.is_deleted = json.is_deleted !== undefined ? json.is_deleted : false;
            organisationMember.is_active = json.is_active !== undefined ? json.is_active : true;
        }
        return organisationMember;
    };
    return OrganisationMemberDocument;
}());
exports.OrganisationMemberDocument = OrganisationMemberDocument;
